function formToggle(radioToggler, manipulatedDiv, parent) {

	parent = parent ? parent : document.body;
	var toggler = $(parent).find('.' + radioToggler);

    toggler.change(function () {
        if ($(this).is(':checked')) 
        {
            $(this).closest(".static-form__inner").find('.' + manipulatedDiv).removeClass('row--hide');
        } 
        else {
            $(this).closest(".static-form__inner").find('.' + manipulatedDiv).addClass('row--hide');
        }
    });

    toggler.closest(".static-form__inner").find("[name=\"" + toggler.attr("name") + "\"]:not(." + radioToggler + ")").on("change", function() {
    	toggler.change();
    });
}

function initFormToggle(parent)
{
	formToggle('js-toggle-problems', 'row-problems', parent);
	formToggle('js-toggle-guarantee', 'row-guarantee', parent);
	formToggle('js-toggle-sms', 'row-sms', parent);
	formToggle('js-toggle-description', 'row-description', parent);
	formToggle('js-toggle-company', 'row-company', parent);
}

initFormToggle();

$(".js-add-repeater").on("click", function(e) {
	if (e) {
		e.preventDefault();
	}

	var repeater = $(".js-form-repeater").last();
	var duplicate = repeater.clone();

	var inputs = duplicate.find(":input");
	initFormToggle(duplicate);


	inputs.each(function(ind, val) {

		var $val = $(val);

		var newName = $val.attr("name").split("").reverse().join("").replace( /(\d+)/, function(){ return arguments[1]*1+1; } );
		newName = newName.split("").reverse("").join("");

		$val.attr("name", newName);

		if ($val.is("[type=checkbox]") || $val.is("[type=radio]")) {
			$val.removeAttr("checked").removeProp("checked").prop("checked", false);
		}
		else {
			$val.val(null);
		}

		$val.change();
	});

	duplicate.find(".form__picker-overlay").each(function(ind, val) {

	  var today = new Date();
	  today.setHours(0);
	  today.setMinutes(0);
	  today.setSeconds(0);
	  today.setMilliseconds(0);

	  $(val).datepicker({
	    minDate: today,
	    title: "Изберете дата",
	    target: $(val).prev("input")
	  });
	  
	});

	duplicate.find(".form__error").remove();
	duplicate.find(".form__group--has-error").removeClass("form__group--has-error");


	repeater.after(duplicate);
});

$(document).on("click", ".js-delete-repeater", function(e) {

	if (e) {
		e.preventDefault();
	}

	$(this).closest(".js-form-repeater").remove();

});

  
$('.upload-file').change(function(e) {
	if (e.target.files.length) {
	    fileName = e.target.files[0].name;
	    $('.file-name').text(fileName);
	}
	else {
		$(".file-name").text("Няма избран файл");
	}
});
